<template>
<div class=" pt-2 mt-2">
    <div v-if="activeTab==='landingTable'">
        <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-text-field v-model="search" prepend-inner-icon="search" v-on:keyup.enter="
            $router.push({
              name: $route.name,
              query: {
                search: search
                }
                })" label="Search"></v-text-field>
        </v-toolbar>
        <v-data-table :items="tableData" :loading="tableloading" :headers="headers" style="cursor: pointer" :rows-per-page-items="[25, 50, 100, 250]">
            <template v-slot:items="props">
                <td class="text-xs-center" @click="viewItem(props.item)" v-if="props.item.deviceMakeModel!==null">{{props.item.deviceMakeModel.deviceType.name}}</td>
                <td class="text-xs-center" @click="viewItem(props.item)" v-if="props.item.deviceMakeModel!==null">{{props.item.deviceMakeModel.deviceMake.name}}</td>
                <td class="text-xs-center" @click="viewItem(props.item)" v-if="props.item.deviceMakeModel!==null">{{props.item.deviceMakeModel.name}}</td>
                <td class="text-xs-center" @click="viewItem(props.item)" v-if="props.item.deviceMakeModel!==null">{{props.item.count}}</td>
                <td class="text-xs-center" @click="viewItem(props.item)" v-if="props.item.deviceMakeModel!==null">{{props.item.activeCount}}</td>
                <td class="text-xs-center" @click="viewItem(props.item)" v-if="props.item.deviceMakeModel!==null">
                    <v-chip>{{props.item.stockCount}}</v-chip>
                </td>
                <!-- <td class="text-xs-center" v-if="props.item.stockWarehouseId!==null">{{props.item.stockWarehouse.name}}</td>
                      <td v-else></td> -->
                <!-- <td class="text-xs-center"><qrcode :width="Number(2)" :value="props.item.qrCode"  /></td> -->
            </template>
        </v-data-table>
    </div>
    <div v-if="activeTab==='warehouseBreakdown'">
        <v-toolbar flat color="white">
            <h3 class="grey--text"><span v-id="item.deviceMakeModel.deviceMake">{{item.deviceMakeModel.deviceMake.name}} </span><span v-id="item.deviceMakeModel">{{item.deviceMakeModel.name}} </span></h3>
            <v-spacer></v-spacer>
            <v-btn flat @click="closeView()">X</v-btn>
        </v-toolbar>
        <v-layout align-top justify-center>
            <v-flex xs3>
                <linechart v-if="loaded" :chartdata="totalStock" :options="totalStockOptions"></linechart>
            </v-flex>
            <v-flex xs3>
                <linechart v-if="loaded" :chartdata="stockMovement" :options="stockMovementOptions"></linechart>
            </v-flex>
            <v-flex xs3>
                <barchart v-if="supplierDataLoaded" :chartdata="stockOrderHistory" :options="stockOrderHistoryOptions"></barchart>
            </v-flex>
            <v-flex xs3>
                <linechart v-if="supplierDataLoaded" :chartdata="priceMovement" :options="priceMovementOptions"></linechart>
            </v-flex>

        </v-layout>
        <v-layout justify-center>
            <v-flex xs3 mx-2>
                <v-card hover>
                    <v-toolbar flat color="white">
                        <h3 class="title grey--text">Stock Locations:</h3>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-flex style="cursor: pointer" xs12 v-for="warehouseItem in wareHouseItems" :key="warehouseItem.id" @click="viewInventoryDevices(warehouseItem)">
                            <v-layout my-1>
                                <v-flex xs6 v-if="warehouseItem.stockWarehouse">
                                    <h3 class="grey--text">{{warehouseItem.stockWarehouse.name}}</h3>
                                </v-flex>
                                <v-flex xs6 v-else>
                                    <h3 class="grey--text">No Allocated Warehouse</h3>
                                </v-flex>
                                <v-flex xs4>
                                    <h3 class="grey--text font-weight-light">{{warehouseItem.quantity}}</h3>
                                </v-flex>
                                <!-- <v-flex xs2><v-icon color="grey" @click="viewWarehouseItems(warehouseItem)">remove_red_eye</v-icon></v-flex> -->
                            </v-layout>
                        </v-flex>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs4 mx-2>
                <v-layout>
                    <v-flex xs12 mx-2>
                        <v-card>
                            <v-toolbar flat color="white">
                                <h3 class="title grey--text font-weight-bold">Movement Log:</h3>
                            </v-toolbar>
                            <v-text-field label="Search" class="mx-3" outlined rounded v-model="searchMovement" clearable></v-text-field>
                            <v-card-text style="overflow-y: auto; max-height:25vh">
                                <v-flex xs12>
                                    <v-list three-line>
                                        <v-list-tile style="border: 1px solid lightgrey" dense v-for="checkout in filterMovementItems" :key="checkout.id" @click="routeToDevice(checkout)">
                                            <v-list-tile-action>
                                                <v-icon color="red" v-if="checkout.type==='checkout'&&!checkout.installedCount">arrow_drop_down</v-icon>
                                                <v-icon color="light-green" v-else-if="!checkout.installedCount">arrow_drop_up</v-icon>
                                                <v-icon v-else color="blue">check_circle_outline</v-icon>
                                            </v-list-tile-action>
                                            <v-list-tile-content>
                                                <v-list-tile-title>
                                                    <span v-if="checkout.device">{{checkout.device.ponMac}}</span>
                                                </v-list-tile-title>
                                                <v-list-tile-subtitle>
                                                    {{checkout.contact.name}} {{checkout.contact.surname}}
                                                </v-list-tile-subtitle>
                                                <span style="font-size: 12px; color: grey">{{formatDate(checkout.updatedAt)}}</span>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </v-list>
                                </v-flex>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs5 mx-2>
                <v-layout justify-center>
                    <v-flex xs12 mx-2>
                        <v-card>
                            <v-toolbar flat color="white">
                                <h3 class="title grey--text font-weight-bold">Order History:</h3>
                            </v-toolbar>
                            <v-divider></v-divider>
                            <v-layout>
                                <v-flex xs12 mx-2>
                                    <v-layout align-center>
                                        <v-flex xs3>
                                            <h3 class="grey--text">Order Date:</h3>
                                        </v-flex>
                                        <v-flex xs3>
                                            <h3 class="grey--text">Supplier:</h3>
                                        </v-flex>
                                        <v-flex xs2>
                                            <h3 class="grey--text">Quantity:</h3>
                                        </v-flex>
                                        <v-flex xs2>
                                            <h3 class="grey--text">USD Unit Price:</h3>
                                        </v-flex>
                                        <v-flex xs2>
                                            <h3 class="grey--text">ZAR Unit Price:</h3>
                                        </v-flex>
                                    </v-layout>
                                    <v-divider></v-divider>
                                    <v-card style="overflow-y: auto; max-height:400px">
                                        <v-flex xs12 v-for="order in orderHistory" :key="order.id" my-1>
                                            <v-card flat hover>
                                                <v-layout align-left justify-left>
                                                    <v-flex xs3>
                                                        <h3 class="grey--text font-weight-light">{{formatDate(order.stockOrder.orderDate)}}</h3>
                                                    </v-flex>
                                                    <v-flex xs3 justify-left>
                                                        <h3 class="grey--text font-weight-light">{{order.stockOrder.supplierOrganisation.name}}</h3>
                                                    </v-flex>
                                                    <v-flex xs2>
                                                        <h3 class="grey--text font-weight-light">{{order.quantity}}</h3>
                                                    </v-flex>
                                                    <v-flex xs2>
                                                        <h3 class="grey--text font-weight-light">${{order.priceUSD}}</h3>
                                                    </v-flex>
                                                    <v-flex xs2>
                                                        <h3 class="grey--text font-weight-light">{{order.priceZAR|currency}}</h3>
                                                    </v-flex>
                                                </v-layout>

                                            </v-card>
                                        </v-flex>
                                    </v-card>

                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>

        <v-dialog v-model="checkoutItemModal" max-width="500px" persistent>
            <v-card>
                <v-card-text>
                    <h2 class="grey--text">Quantity to Checkout:</h2>
                    <v-text-field type="number" flat outline solo v-model="checkoutQuantity"></v-text-field>
                    <v-card-actions>
                        <v-layout justify-center>
                            <v-btn round class="white--text" color="red" @click="checkoutQuantity=0,checkoutItemModal=false">Cancel</v-btn>
                            <v-btn round class="white--text" v-if="selectedCheckoutItem !==null&&checkoutQuantity<=selectedCheckoutItem.quantity" color="light-green" @click="submitCheckout()">Submit</v-btn>
                            <v-btn v-else disabled round>Submit</v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="viewInventoryDevicesModal" persistent width="750px">
            <v-card flat color="white" v-if="activeWarehouse">
                <v-toolbar flat color="primary">
                    <h3 class="title white--text"><span v-if="activeWarehouse.stockWarehouse">{{activeWarehouse.stockWarehouse.name}}:</span>
                        <v-chip>{{activeWarehouse.quantity}}</v-chip> in Stock
                    </h3>
                    <v-spacer></v-spacer>
                    <v-btn flat color="white" @click="viewInventoryDevicesModal=false, activeWarehouse=null">X</v-btn>
                </v-toolbar>
                <v-toolbar flat color="white">
                    <v-spacer></v-spacer>
                    <v-text-field label="Search" v-model="inventorySearch"></v-text-field>
                </v-toolbar>
                <v-card-text>
                    <v-data-table :items="inventoryDevices" :search="inventorySearch" :headers="inventoryHeaders" style="cursor: pointer" :rows-per-page-items="[25, 50, 100, 250]">
                        <template v-slot:items="props">
                            <td @click="redirectToDevice(props.item)" class="text-xs-center">{{props.item.ponMac}}</td>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</div>
</template>

<script>
import Api from "@/services/Api";
import Qrcode from 'vue-qrcode';
import dateformat from "dateformat";
import BarChart from './BarChart.vue';
import PieChart from './PieChart.vue';
import LineChart from './LineChart.vue';
import DoughnutChart from './DoughnutChart.vue';
export default {
    props: ['allactiveinventory', 'activeinventory', 'devicemakemodels', 'tableloading'],
    components: {
        Qrcode,
        barchart: BarChart,
        piechart: PieChart,
        linechart: LineChart,
        doughnutchart: DoughnutChart
    },
    data() {
        return {
            activeWarehouse: null,
            search: '',
            tableData: this.activeinventory,
            selectedStockType: null,
            item: null,
            wareHouseItems: [],
            checkoutItems: [],
            movementItems: [],
            specificWarehouseItems: [],
            checkoutItemModal: false,
            checkoutQuantity: 0,
            selectedCheckoutItem: null,
            loaded: false,
            supplierDataLoaded: false,
            totalStock: [],
            totalStockOptions: {},
            stockMovement: [],
            orderHistory: [],
            stockMovementOptions: {},
            stockOrderHistory: [],
            stockOrderHistoryOptions: {},
            priceMovement: [],
            priceMovementOptions: {},
            inventoryDevices: [],
            inventorySearch: '',
            viewInventoryDevicesModal: false,
            activeTab: 'landingTable',
            searchMovement: '',
            inventoryHeaders: [{
                text: "Pon Mac",
                align: "center",
                value: "ponMac"
            }, ],
            headers: [{
                    text: "Type",
                    align: "center",
                    value: "deviceMakeModel.deviceType.name"
                },
                {
                    text: "Make",
                    align: "center",
                    value: "deviceMakeModel.deviceMake.name"
                },
                {
                    text: "Model",
                    align: "center",
                    value: "deviceMakeModel.name"
                },
                {
                    text: "Quantity",
                    align: "center",
                    value: "count"
                },
                {
                    text: "Active Devices",
                    align: "center",
                    value: "activeCount"
                },
                {
                    text: "In Stock",
                    align: "center",
                    value: "stockCount"
                }
            ],
            warehouseHeaders: [{
                    text: "Quantity",
                    align: "center",
                    value: "quantity"
                },
                {
                    text: "Warehouse",
                    align: "center",
                    value: "stockWarehouse.name"
                }
            ]
        }
    },
    // created(){
    //     this.tableData=this.activeinventory
    // },
    computed: {
        filterMovementItems() {
            let result = this.movementItems ? this.movementItems : []
            if (this.searchMovement) {
                result = result.filter(x =>
                    (x.device.ponMac.toLowerCase()).includes(this.searchMovement.toLowerCase()) ||
                    (x.contact.name.toLowerCase() + x.contact.surname.toLowerCase()).includes(this.searchMovement.toLowerCase())
                )
            }
            return result
        }
    },
    watch: {
        "$route.query.search": {
            immediate: true,
            async handler(value) {
                if (this.$route.query.search && value !== "" && value != null) {
                    await Api()
                        .get("/devices/inventory", {
                            params: {
                                search: value,
                            },
                        })
                        .then(async (response) => {
                            var helper = {};
                            var result = response.data.reduce(function (r, o) {
                                var key = o.deviceMakeModelId;
                                if (!helper[key]) {
                                    helper[key] = Object.assign({}, o);
                                    if (o.isActive && !o.isDeleted) {
                                        helper[key].count = 1;
                                        if (!o.inStock) {
                                            helper[key].activeCount = 1;
                                            helper[key].stockCount = 0;
                                        } else {
                                            helper[key].activeCount = 0;
                                            helper[key].stockCount = 1;
                                        }
                                        r.push(helper[key]);
                                    }
                                } else {
                                    if (o.isActive && !o.isDeleted) {
                                        helper[key].count += 1;
                                        if (!o.inStock) {
                                            helper[key].activeCount += 1;
                                        } else {
                                            helper[key].stockCount += 1;
                                        }
                                    }
                                }
                                return r;
                            }, []);
                            this.tableData = result;
                        })
                } else if (value === "") {
                    await Api()
                        .get("/devices/inventory")
                        .then(async (response) => {
                            var helper = {};
                            var result = response.data.reduce(function (r, o) {
                                var key = o.deviceMakeModelId;
                                if (!helper[key]) {
                                    helper[key] = Object.assign({}, o);
                                    if (o.isActive && !o.isDeleted) {
                                        helper[key].count = 1;
                                        if (!o.inStock) {
                                            helper[key].activeCount = 1;
                                            helper[key].stockCount = 0;
                                        } else {
                                            helper[key].activeCount = 0;
                                            helper[key].stockCount = 1;
                                        }
                                        r.push(helper[key]);
                                    }
                                } else {
                                    if (o.isActive && !o.isDeleted) {
                                        helper[key].count += 1;
                                        if (!o.inStock) {
                                            helper[key].activeCount += 1;
                                        } else {
                                            helper[key].stockCount += 1;
                                        }
                                    }
                                }
                                return r;
                            }, []);
                            this.tableData = result;
                        })
                }
            }
        },
        async selectedStockType(value) {
            if (value !== null && typeof value !== 'undefined' && value != '') {
                this.tableData = await this.activeinventory.filter(function (el) {
                    return el.stockItem.stockTypeId === value
                })
            } else {
                this.tableData = this.activeinventory
            }
        }
    },
    created() {

        // this.tableData=result
    },
    methods: {
        formatDate(date) {
            if (date !== null) {
                return dateformat(date, "dd/mm/yyyy HH:MM");
            } else {
                null;
            }
        },
        formatMonth(date) {
            if (date !== null) {
                return dateformat(date, "mm/yyyy");
            } else {
                null;
            }
        },
        redirectToDevice(item) {
            this.$router.push({
                path: '/devices/' + item.id
            })
        },
        async submitCheckout() {
            let stockItemId = this.selectedCheckoutItem.stockItemId
            let stockWarehouseId = this.selectedCheckoutItem.stockWarehouseId
            let fifo = await this.activeinventory.filter(function (x) {
                return x.stockItemId === stockItemId && x.stockWarehouseId === stockWarehouseId
            })
            if (fifo[0].quantity >= this.checkoutQuantity) {
                Api()
                    .put('/passiveEquipment/' + fifo[0].id, {
                        quantity: fifo[0].quantity - this.checkoutQuantity
                    }).then(response => {
                        let index = this.wareHouseItems.indexOf(this.selectedCheckoutItem)
                        this.wareHouseItems[index].quantity = this.wareHouseItems[index].quantity - this.checkoutQuantity
                    })
            } else {
                let quantity = this.checkoutQuantity
                let array = []
                for (let i = 0; i < fifo.length; i++) {
                    if (quantity > 0) {
                        if (quantity >= fifo[i].quantity) {
                            array.push({
                                id: fifo[i].id,
                                quantity: fifo[i].quantity,
                                index: i
                            })
                            quantity -= fifo[i].quantity
                        } else {
                            array.push({
                                id: fifo[i].id,
                                quantity: quantity,
                                index: i
                            })
                            quantity -= quantity
                        }
                    }
                }
                array.map(x => {
                    Api()
                        .put('/passiveEquipment/' + x.id, {
                            quantity: fifo[x.index].quantity - x.quantity
                        }).then(response => {
                            let index = this.wareHouseItems.indexOf(this.selectedCheckoutItem)
                            this.wareHouseItems[index].quantity = this.wareHouseItems[index].quantity - x.quantity
                        })
                })
            }

            Api()
                .post('/checkoutItem', {
                    stockItemId: this.selectedCheckoutItem.stockItemId,
                    stockWarehouseId: this.selectedCheckoutItem.stockWarehouseId,
                    count: this.checkoutQuantity,
                    isActive: true,
                    isDeleted: false
                }).then(response => {
                    this.getStockCheckout(this.selectedCheckoutItem.stockItemId)
                    // this.checkoutItems.push(response.data)
                    this.checkoutQuantity = 0
                    this.checkoutItemModal = false
                    this.selectedCheckoutItem = null
                })
        },
        checkOutItem(item) {
            this.selectedCheckoutItem = item
            this.checkoutItemModal = true
        },
        closeView() {
            this.activeTab = 'landingTable'
            this.item = null
            this.wareHouseItems = []
            this.loaded = false,
                this.supplierDataLoaded = false
            this.totalStock = []
            this.totalStockOptions = {}
            this.stockMovement = []
            this.orderHistory = []
            this.stockMovementOptions = {}
            this.stockOrderHistory = []
            this.stockOrderHistoryOptions = {}
            this.priceMovement = []
            this.priceMovementOptions = {}
        },
        async viewItem(item) {
            this.item = Object.assign({}, item);
            this.getStockCheckout(item.deviceMakeModelId)
            this.getStockItemOrderHistory(item.deviceMakeModelId)
            let id = item.deviceMakeModelId
            let array = await this.allactiveinventory.filter(function (el) {
                return el.deviceMakeModelId === id && el.stockWarehouseId != null && el.locationId == null
            })
            var helper = {};
            var result = array.reduce(function (r, o) {
                var key = o.stockWarehouseId;
                if (!helper[key]) {
                    helper[key] = Object.assign({}, o);
                    helper[key].quantity = 1
                    r.push(helper[key]);
                } else {
                    if (o.isActive && !o.isDeleted) {
                        helper[key].quantity += 1;
                    }
                }
                return r;
            }, []);

            this.wareHouseItems = result
            this.activeTab = 'warehouseBreakdown'
        },
        async getStockCheckout(id) {
            var movementItems = []
            let checkoutItems = []
            await Api()
                .get('/checkoutItem/byDeviceMakeModel/' + id)
                .then(async response => {
                    // this.checkoutItems=response.data
                    // movementItems=response.data
                    await response.data.forEach(function (element) {
                        element.type = "checkout";
                    })
                    checkoutItems = response.data
                })
            let checkinItems = []
            await Api()
                .get('/checkinItem/byDeviceMakeModel/' + id)
                .then(async response => {
                    // this.checkoutItems=response.data
                    response.data = response.data.filter(x=>!x.checkoutItemId)
                    await response.data.map(y => {
                        y.type = 'checkin'
                    })
                    checkinItems = response.data
                })
            movementItems = [...checkoutItems, ...checkinItems]
            let array = movementItems.sort((a, b) => (a.updatedAt > b.updatedAt) ? 1 : ((b.updatedAt > a.updatedAt) ? -1 : 0));
            this.movementItems = array
            var stockLevels = []
            await array.reverse().map(a => {
                let number = 1
                if (a.type === 'checkout') {
                    number = -1
                }
                if (stockLevels.length === 0) {
                    stockLevels.push({
                        date: a.updatedAt,
                        type: a.type,
                        count: number
                    })
                } else {
                    let value = stockLevels[stockLevels.length - 1].count + number
                    stockLevels.push({
                        date: a.updatedAt,
                        type: a.type,
                        count: value
                    })
                }
            })
            let groups = await stockLevels.reduce(function (r, o) {
                var m = o.date.split(('-'))[0] + '-' + o.date.split(('-'))[1];
                (r[m]) ? r[m].data.push(o): r[m] = {
                    group: String(m),
                    data: [o]
                };
                return r;
            }, {});

            var result = await Object.keys(groups).map(function (k) {
                return groups[k];
            });

            await result.map(async b => {
                // b.total = b.data.reduce((a, b) => +a + +b.count, 0)
                let index = await result.indexOf(b)
                if (index === 0) {
                    b.movement = b.data[b.data.length - 1].count
                    b.total = b.data[b.data.length - 1].count
                } else {
                    b.movement = b.data[b.data.length - 1].count - result[index - 1].total
                    b.total = b.data[b.data.length - 1].count
                }
            })
            this.initiateGraph(result)

        },
        routeToDevice(item) {
            this.$router.push({
                path: "/devices/" + item.deviceId
            });
        },
        initiateGraph(array) {
            this.totalStock = {
                    labels: array.map(x => x.group),
                    datasets: [{
                        label: 'Month',
                        data: array.map(x => x.total),
                        backgroundColor: 'rgba(255, 99, 132, 0.2)',
                        borderColor: 'rgba(255, 99, 132, 1)',
                        borderWidth: 1
                    }]
                },
                this.totalStockOptions = {

                    title: {
                        display: true,
                        text: 'Total Stock'
                    },
                    tooltip: {
                        enabled: true
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                },
                this.stockMovement = {
                    labels: array.map(x => x.group),
                    datasets: [{
                        label: 'Movement',
                        data: array.map(x => x.movement),
                        backgroundColor: 'rgba(54, 162, 235, 0.2)',
                        borderColor: 'rgba(54, 162, 235, 1)',
                        borderWidth: 1
                    }]
                },
                this.stockMovementOptions = {

                    title: {
                        display: true,
                        text: 'Total Movements'
                    },
                    tooltip: {
                        enabled: true
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                }

            this.loaded = true
        },
        viewInventoryDevices(item) {
            console.log(this.tableData)
            this.activeWarehouse = item
            this.inventoryDevices = this.allactiveinventory.filter(x => x.stockWarehouseId === item.stockWarehouseId && x.deviceMakeModelId === item.deviceMakeModelId)
            this.viewInventoryDevicesModal = true
            console.log(item)
        },
        async getStockItemOrderHistory(id) {
            await Api()
                .get('/stockOrderItem/byDeviceMakeModel/' + id)
                .then(async response => {
                    this.orderHistory = response.data.sort((a, b) => (a.orderDate < b.orderDate) ? 1 : ((b.orderDate < a.orderDate) ? -1 : 0));
                    await this.orderHistory.map(async b => {
                        if (b.stockOrder.supplierOrganisation.name.length > 10) {
                            var trimmedString = await b.stockOrder.supplierOrganisation.name.substr(0, 12);
                            trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, b.stockOrder.supplierOrganisation.name.indexOf(" ")))
                            b.stockOrder.supplierOrganisation.name = trimmedString
                        }
                    })
                    let supplierGroup = this.orderHistory.reduce(function (r, o) {
                        var m = o.stockOrder.supplierOrganisationId;
                        (r[m]) ? r[m].data.push(o): r[m] = {
                            supplierOrganisationId: (m),
                            supplierOrganisation: o.stockOrder.supplierOrganisation,
                            data: [o]
                        };
                        return r;
                    }, {});
                    let cost = this.orderHistory.reduce(function (r, o) {
                        var m = o.stockOrder.orderDate.split(('-'))[0] + '-' + o.stockOrder.orderDate.split(('-'))[1];
                        (r[m]) ? r[m].data.push(o): r[m] = {
                            group: String(m),
                            data: [o]
                        };
                        return r;
                    }, {});

                    var supplierResult = Object.keys(supplierGroup).map(function (k) {
                        return supplierGroup[k];
                    });
                    var costResult = Object.keys(cost).map(function (k) {
                        return cost[k];
                    });

                    await supplierResult.map(async b => {
                        //   if(b.supplierOrganisation.name.length > 10){
                        //     var trimmedString = await b.supplierOrganisation.name.substr(0, 12);
                        //     trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, b.supplierOrganisation.name.indexOf(" ")))
                        //     b.supplierOrganisation.name=trimmedString
                        // }
                        b.total = b.data.reduce((a, b) => +a + +b.quantity, 0)
                    })
                    supplierResult.sort((a, b) => (a.total < b.total) ? 1 : ((b.total < a.total) ? -1 : 0));
                    await costResult.map(b => {
                        b.totalPrice = b.data.reduce((a, b) => +a + +b.quantity * b.priceZAR, 0)
                        b.totalUnits = b.data.reduce((a, b) => +a + +b.quantity, 0)
                        b.averagePrice = Math.round((b.totalPrice / b.totalUnits) * 100) / 100
                    })
                    this.initiateSupplierGraph(supplierResult, costResult)
                })
        },

        async initiateSupplierGraph(supplierData, costData) {
            this.stockOrderHistory = {
                    labels: await supplierData.map(x => x.supplierOrganisation.name),
                    datasets: [{
                        label: 'Orders',
                        data: await supplierData.map(x => x.total),
                        backgroundColor: 'rgba(74, 168, 50, 0.2)',
                        borderColor: 'rgba(74, 168, 50, 1)',
                        borderWidth: 1
                    }]
                },
                this.stockOrderHistoryOptions = {

                    title: {
                        display: true,
                        text: 'Orders Per Supplier'
                    },
                    tooltip: {
                        enabled: true
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                }
            this.priceMovement = {
                    labels: await costData.map(x => x.group),
                    datasets: [{
                        label: 'Price Movement',
                        data: await costData.map(x => x.averagePrice),
                        backgroundColor: 'rgba(58, 50, 168, 0.2)',
                        borderColor: 'rgba(58, 50, 168, 1)',
                        borderWidth: 1
                    }]
                },
                this.priceMovementOptions = {

                    title: {
                        display: true,
                        text: 'Average Price per Unit (ZAR)'
                    },
                    tooltip: {
                        enabled: true
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                }
            this.supplierDataLoaded = true
        },
        async viewWarehouseItems(item) {
            let id = item.deviceMakeModelId
            let stockWarehouseId = item.stockWarehouseId
            this.specificWarehouseItems = await this.allactiveinventory.filter(function (el) {
                return el.deviceMakeModelId === id && el.stockWarehouseId === stockWarehouseId
            })
        }
    }
}
</script>
